export enum ItemsToCopyField {
  PARTS = 'parts',
}
